{
    "tapi_integration__no_phone": "Keine Telefonnummer angegeben",
    "tapi_integration__usage": "Verwendung: /integrations/tapi/[Telefonnummer]",
    "tapi_integration__error": "Fehler beim Nachschlagen der Telefonnummer",
    "tapi_integration__looking_up": "Suche nach Telefonnummer",
    "tapi_integration__no_match": "Kein Kunde für Telefonnummer gefunden:",
    "tapi_integration__no_match_help": "Die Telefonnummer ist möglicherweise nicht im System registriert oder das Format stimmt nicht überein."
}
